import { useIntl } from 'react-intl'

import { TENANT } from '../../tenant'

type CustomerSupportTexts = {
  entireWeekLabel: string
  getFooterDisclaimerText: () => string
  getPhoneNumber: () => string
  getTimeframe: () => string
  getWeekdaysOrEntireWeekLabel: () => string
  shouldRenderSaturdaysLine: () => boolean
  weekdaysLabel: string
}

export const useDirectContactFormTelephoneTranslations = (
  isPharmaModal: boolean,
  tenant: TENANT,
): CustomerSupportTexts => {
  const intl = useIntl()
  const tenantsWithPricedCall = new Set<TENANT>([
    TENANT.AT,
    TENANT.BE,
    TENANT.COM,
    TENANT.IT,
  ])
  const tenantsWithDifferentAvailabilityOnSaturdays = new Set<TENANT>([
    TENANT.AT,
    TENANT.BE,
    TENANT.CH,
    TENANT.FR,
    TENANT.IT,
  ])

  const freeCallDisclaimerText = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.freeCallDisclaimer',
  })

  const paidCallDisclaimerText = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.priceDisclaimer',
  })

  const weekdaysLabel = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.weekdays.label',
  })

  const entireWeekLabel = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.entireWeek.label',
  })

  const getTimeframe = (): string => {
    if (isPharmaModal) {
      return intl.formatMessage({
        id: 'contact.directContactSection.customerSupportDialog.availableTimeframe.pharma',
      })
    }

    return intl.formatMessage({
      id: 'contact.directContactSection.customerSupportDialog.availableTimeframe',
    })
  }

  const getPhoneNumber = (): string => {
    if (isPharmaModal) {
      return intl.formatMessage({
        id: 'contact.directContact.customerSupport.phoneNumber.pharma',
      })
    }

    return intl.formatMessage({
      id: 'contact.directContact.customerSupport.phoneNumber',
    })
  }

  const getFooterDisclaimerText = (): string => {
    if (!isPharmaModal && tenantsWithPricedCall.has(tenant)) {
      return paidCallDisclaimerText
    }

    return freeCallDisclaimerText
  }

  const shouldRenderSaturdaysLine = (): boolean => {
    if (tenant === TENANT.IT) {
      return false
    }

    return (
      isPharmaModal || tenantsWithDifferentAvailabilityOnSaturdays.has(tenant)
    )
  }

  const getWeekdaysOrEntireWeekLabel = (): string => {
    if (
      isPharmaModal ||
      tenantsWithDifferentAvailabilityOnSaturdays.has(tenant)
    ) {
      return weekdaysLabel
    }

    return entireWeekLabel
  }

  return {
    entireWeekLabel,
    getFooterDisclaimerText,
    getPhoneNumber,
    getTimeframe,
    getWeekdaysOrEntireWeekLabel,
    shouldRenderSaturdaysLine,
    weekdaysLabel,
  }
}
